import { render, staticRenderFns } from "./StockviewSliderFilter.vue?vue&type=template&id=9da169c8&"
import script from "./StockviewSliderFilter.vue?vue&type=script&lang=js&"
export * from "./StockviewSliderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports